(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-free-guide"] && !Shopify.designMode) return;
  try {
    
  /* lead form posts through the captureLead seam so the visitor stays on the
     page and sees the confirmation; without JS the native customer form posts
     and Liquid renders the same success block */
  (function () {
    var form = document.getElementById('lead-form');
    var tpl = document.getElementById('lm-ok-tpl');
    if (!form || !tpl) return;
    form.addEventListener('submit', function (e) {
      if (!window.captureLead) return;
      var emailInput = form.querySelector('[name="contact[email]"]');
      var nameInput = form.querySelector('[name="contact[first_name]"]');
      var tagsInput = form.querySelector('[name="contact[tags]"]');
      var btn = form.querySelector('button[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var name = nameInput ? nameInput.value.trim() : '';
      if (!/.+@.+\..+/.test(email)) return;
      e.preventDefault();
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Sending...';
      }
      try {
        localStorage.setItem('zc_email', email);
        if (name) localStorage.setItem('zc_name', name);
      } catch (err) {}
      var sent = window.captureLead({
        email: email,
        name: name,
        tags: tagsInput ? tagsInput.value : '',
      });
      (sent && sent.then ? sent : Promise.resolve()).then(function () {
        form.replaceWith(tpl.content.cloneNode(true));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dataEl = document.getElementById('zqData');
    if (!dataEl) return;
    var D;
    try {
      D = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var Q = D.questions || [];
    if (!Q.length) return;
    var cur = 0,
      answered = false,
      answers = [],
      orders = [];
    function el(id) {
      return document.getElementById(id);
    }
    var start = el('zqStart'),
      card = el('zqCard'),
      prog = el('zqProg'),
      result = el('zqResult'),
      review = el('zqReview');
    /* email gate — same lead seam as the popup */
    var em = el('zqEmail');
    try {
      var saved = localStorage.getItem('zc_email') || '';
      if (saved) em.value = saved;
    } catch (e) {}
    el('zqGate').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = em.value.trim();
      if (!/.+@.+\..+/.test(v)) {
        el('zqErr').classList.add('show');
        return;
      }
      el('zqErr').classList.remove('show');
      try {
        localStorage.setItem('zc_email', v);
      } catch (e2) {}
      if (window.captureLead) window.captureLead({ email: v, tags: 'quiz' });
      start.classList.remove('show');
      card.hidden = false;
      prog.hidden = false;
      renderQ();
      window.scrollTo(0, 0);
    });
    function shuffle(n) {
      var a = [];
      for (var i = 0; i < n; i++) a.push(i);
      for (var j = a.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var t = a[j];
        a[j] = a[k];
        a[k] = t;
      }
      return a;
    }
    function renderQ() {
      var q = Q[cur];
      answered = false;
      el('zqNum').textContent = 'Question ' + (cur + 1);
      if (q.s) {
        el('zqText').innerHTML = '<span class="zq-scenario">Scenario</span><br>';
        el('zqText').appendChild(document.createTextNode(q.t));
      } else {
        el('zqText').textContent = q.t;
      }
      var opts = el('zqOpts');
      opts.innerHTML = '';
      orders[cur] = orders[cur] || shuffle(q.opts.length);
      orders[cur].forEach(function (origIdx) {
        if (!q.opts[origIdx]) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'zq-opt';
        b.textContent = q.opts[origIdx];
        b.addEventListener('click', function () {
          if (answered) return;
          answered = true;
          answers[cur] = origIdx;
          opts.querySelectorAll('.zq-opt').forEach(function (x) {
            x.classList.add('dim');
          });
          b.classList.remove('dim');
          b.classList.add('selected');
          el('zqAffirmTx').textContent = q.a || '';
          if (q.a) el('zqAffirm').classList.add('show');
          el('zqNext').classList.add('show');
        });
        opts.appendChild(b);
      });
      el('zqAffirm').classList.remove('show');
      el('zqNext').classList.remove('show');
      el('zqProgFill').style.width = Math.round((cur / Q.length) * 100) + '%';
      el('zqProgCt').textContent = cur + 1 + ' of ' + Q.length;
      el('zqNext').textContent = cur === Q.length - 1 ? 'See my result' : 'Next question';
    }
    el('zqNext').addEventListener('click', function () {
      cur++;
      if (cur >= Q.length) showResult();
      else renderQ();
      window.scrollTo(0, 0);
    });
    function score() {
      var s = 0;
      for (var i = 0; i < Q.length; i++) if (answers[i] === 0) s++;
      return s;
    }
    function showResult() {
      card.hidden = true;
      prog.hidden = true;
      review.classList.remove('show');
      var s = score(),
        pct = Math.round((s / Q.length) * 100);
      el('zqResScore').textContent = 'Readiness score: ' + s + ' / ' + Q.length;
      el('zqResBar').style.width = pct + '%';
      var t, sub;
      if (s >= D.hiMin) {
        t = D.hiTitle;
        sub = D.hiSub;
      } else if (s >= D.midMin) {
        t = D.midTitle;
        sub = D.midSub;
      } else {
        t = D.loTitle;
        sub = D.loSub;
      }
      el('zqResTitle').textContent = t;
      el('zqResSub').textContent = sub;
      result.classList.add('show');
      try {
        var email = localStorage.getItem('zc_email');
        if (email && window.captureLead)
          window.captureLead({ email: email, tags: 'quiz,quiz-completed,quiz-score-' + s });
      } catch (e) {}
      window.scrollTo(0, 0);
    }
    el('zqReviewLink').addEventListener('click', function () {
      var list = el('zqReviewList');
      list.innerHTML = '';
      el('zqReviewScore').innerHTML = 'Your score: <b>' + score() + ' / ' + Q.length + '</b>';
      Q.forEach(function (q, i) {
        var chosen =
          answers[i] != null && q.opts[answers[i]] != null ? q.opts[answers[i]] : 'Not answered';
        var good = answers[i] === 0;
        var item = document.createElement('div');
        item.className = 'zq-rev';
        var num = document.createElement('div');
        num.className = 'zq-num';
        num.textContent = (q.s ? 'Scenario · ' : '') + 'Question ' + (i + 1);
        var qt = document.createElement('div');
        qt.className = 'zq-rev-q';
        qt.textContent = q.t;
        item.appendChild(num);
        item.appendChild(qt);
        function row(ok, label, text) {
          var r = document.createElement('div');
          r.className = 'zq-rev-a' + (ok ? ' good' : '');
          r.innerHTML =
            '<span class="zq-mark ' + (ok ? 'ok' : 'no') + '">' + (ok ? '✓' : '✕') + '</span>';
          var col = document.createElement('span');
          var l = document.createElement('span');
          l.className = 'zq-rev-lbl';
          l.textContent = label;
          col.appendChild(l);
          col.appendChild(document.createTextNode(text));
          r.appendChild(col);
          return r;
        }
        item.appendChild(row(good, 'Your answer', chosen));
        if (!good) item.appendChild(row(true, 'Strongest answer', q.opts[0]));
        list.appendChild(item);
      });
      result.classList.remove('show');
      review.classList.add('show');
      window.scrollTo(0, 0);
    });
    el('zqBack').addEventListener('click', function () {
      review.classList.remove('show');
      result.classList.add('show');
      window.scrollTo(0, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
